import { render, staticRenderFns } from "./editsetting.vue?vue&type=template&id=b8587d18&"
import script from "./editsetting.vue?vue&type=script&lang=js&"
export * from "./editsetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports